var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '@shapeable/theme';
import { breakpoints } from '@shapeable/theme';
import { LoadingLayout } from '../elements/loading-layout';
import { WaitMessage } from '../elements/wait-message';
import { useIdleTimer } from 'react-idle-timer';
import { useLang } from '../hooks/use-lang';
import { EntityConversation } from './entity-conversation';
import { entityTypeNameFor } from '@shapeable/utils';
import { useActivePerson } from '../hooks/use-active-person';
import { useEntityCommentsQuery } from '../hooks/use-entity-comments-query';
import { RefetchProvider } from '../context/refetch-context';
export var EntityConversationLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    overflow: auto;\n    display: flex;\n    flex-direction: column-reverse;\n    ", "\n"], ["\n    position: relative;\n    overflow: auto;\n    display: flex;\n    flex-direction: column-reverse;\n    ", "\n"])), function (props) {
    return props._height && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props._height);
  })
});
var ConversationStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var WaitMessageStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(-10))
});
var WaitMessageContainerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    max-width: ", ";\n    margin: 0 auto;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])), theme.MAX('content-width'))
});
var EmptyLayoutStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 100%;\n    display: flex;\n    padding: ", ";\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n    font-size: 1.3em;\n    font-weight: 500;\n    color: ", ";\n  "], ["\n    height: 100%;\n    display: flex;\n    padding: ", ";\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n    font-size: 1.3em;\n    font-weight: 500;\n    color: ", ";\n  "])), theme.UNIT(4), theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LoadingLayout: LoadingLayout,
  Conversation: styled(EntityConversation)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ConversationStyles),
  WaitMessageContainer: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageContainerStyles),
  WaitMessage: styled(WaitMessage)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), WaitMessageStyles),
  EmptyLayout: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), EmptyLayoutStyles)
};
export var EntityConversationLayout = function (props) {
  var className = props.className,
    entity = props.entity;
  var _a = __read(useState(false), 2),
    isIdle = _a[0],
    setIsIdle = _a[1];
  var _b = __read(useState(false), 2),
    showEmptyMessage = _b[0],
    setShowEmptyMessage = _b[1];
  var _c = __read(useState(true), 2),
    isInitialLoad = _c[0],
    setIsInitialLoad = _c[1];
  var t = useLang();
  var activePerson = useActivePerson().person;
  var type = entityTypeNameFor(entity);
  var _d = useEntityCommentsQuery({
      entityTypeName: type,
      slug: entity === null || entity === void 0 ? void 0 : entity.slug,
      isIdle: isIdle
    }),
    commentsData = _d.data,
    loading = _d.loading,
    error = _d.error,
    oneName = _d.oneName,
    refetch = _d.refetch;
  var hasComments = (commentsData === null || commentsData === void 0 ? void 0 : commentsData.length) > 0;
  useIdleTimer({
    onIdle: function () {
      return setIsIdle(true);
    },
    onActive: function () {
      return setIsIdle(false);
    },
    timeout: 10000
  });
  // Reset for a new trend or conversation
  useEffect(function () {
    setIsInitialLoad(true);
    setShowEmptyMessage(false);
  }, [entity === null || entity === void 0 ? void 0 : entity.slug]);
  // Show 'start a convo message' if no comments and timeout has completed - message was being shown briefly between loading and comments being fetched - stops message flickering
  // Also prevents the loader from flickering during the polling interval
  useEffect(function () {
    if (!loading) {
      setIsInitialLoad(false);
      if (!hasComments) {
        var timeoutId_1 = setTimeout(function () {
          return setShowEmptyMessage(true);
        }, 100);
        return function () {
          return clearTimeout(timeoutId_1);
        };
      } else {
        setShowEmptyMessage(false);
      }
    }
  }, [loading, hasComments]);
  var showLoader = loading && isInitialLoad;
  return React.createElement(RefetchProvider, {
    value: refetch
  }, React.createElement(My.Container, {
    _height: 50,
    className: className
  }, React.createElement(My.Conversation, {
    isLoading: showLoader,
    entity: entity,
    stretch: true,
    comments: commentsData
  }), showLoader && React.createElement(My.WaitMessageContainer, null, React.createElement(My.WaitMessage, {
    loading: loading
  }, t('Loading. Please wait...'))), showEmptyMessage && React.createElement(My.EmptyLayout, null, t("Start a Conversation About ".concat(entity.name)))));
};
EntityConversationLayout.defaultProps = EntityConversationLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;